import { Auth0ProviderWithConfigOptions } from '@auth0/auth0-react'
import { authConfig } from './authConfig'

const SELECTED_ORG_KEY = 'gambyt_selected_org'
let currentOrg = ''

// See https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
export function getAuthConfig(): Auth0ProviderWithConfigOptions {
  const urlParams = new URLSearchParams(window.location.search)
  const invitation = urlParams.get('invitation')
  const organization = urlParams.get('organization')

  const resolvedOrg = currentOrg || localStorage.getItem(SELECTED_ORG_KEY) || undefined

  return {
    domain: authConfig.domain,
    clientId: authConfig.clientId,
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    authorizationParams: {
      invitation: invitation ? encodeURIComponent(invitation) : undefined,
      screen_hint: invitation ? 'signup' : 'login',
      redirect_uri: window.location.origin,
      audience: authConfig.audience,
      organization: organization ? encodeURIComponent(organization) : resolvedOrg,
    },
  }
}

export function setAuthOrg(org: string): void {
  currentOrg = org
  localStorage.setItem(SELECTED_ORG_KEY, org)
}
